export default {
	BLUE: 'blue',
	DARK: 'dark',
	LIGHT: 'light',
	WHITE: 'white',
}
